import { Button, Intent, Popover, Position } from "@blueprintjs/core"
import { useEffect, useRef, useState } from "react"
import { ID, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { template } from "src/libs/layouts"
import { LayoutIcon } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import useClickOutside from "src/modules/pe-fest-module/widgets/hooks/useClickOutside"
import { ILandFilter, LAND_FILTER_TYPE, LANDS_FILTER_ICON_URL } from "../data/interfaces"
import { IToposStore, useToposStore } from "../data/store"
import useFeedRoute from "../hooks/useFeedRoute"

 
const LandFilterWidget = () : JSX.Element => {  
    return <LandFilters />   
}

export const LandFilters = () : JSX.Element => {
    const lands: ILand[] = useDataStore((state: any) => state.LandTop || [])
    const landFilter: ILandFilter = useToposStore((state:IToposStore) => state.landFilter) 
    const {width} = useScreenSize() 
    const isScreen = width > WINDOW_WIDTH.TABLET 
    const [title, setTitle] = useState( __( "all Lands" ) )
    const [icon, setIcon] = useState( LANDS_FILTER_ICON_URL )
    const [isOpen, setOpen] = useState(false) 
    
    const myRef: React.MutableRefObject<null> = useRef( null )
    const isRoute: boolean = useFeedRoute()
    
    const onOpen = (isOpen:boolean) =>
    {
        setOpen(isOpen)
    }
    let timeOut: any = -1    
    useClickOutside( myRef, onOpen, timeOut)

    useEffect( () => {
        actions(GET_FEED_ACTION, {
            data_type: "Land",
            seed: "Top",
            paging: ` meta_relation: "AND" metas: [ { key: "hidden", value_bool: false }, { key: "mine", value: "" } ] `
        })
    }, [] )
     
    const handleLoginOpen = () =>
    {
        clearTimeout( timeOut )
        onOpen(true)
    }

    const setFilter = (landId: ID) => {
        setTitle(
            landId === "all"
                ?
                __("all Lands")
                :
                lands.filter( land => land.id === landId )[0]?.name

        )
        setIcon(
            landId === "all"
                ?
                LANDS_FILTER_ICON_URL
                :
                lands.filter( land => land.id === landId )[0]?.icon || LANDS_FILTER_ICON_URL
        )
        useToposStore.setState({ landFilter: { type:LAND_FILTER_TYPE.LAND, id: landId } })
    } 
    const onMouseLeave = () =>
    {
        clearTimeout( timeOut )
        timeOut = setTimeout(() =>
        {
            onOpen(false)
        }, 1000)
    }
    const menuHeight =  isScreen ?  template().header?.height || 0 : 75
    return <>   
        <div 
            className={`indicator dble lrg classic p-0 m-0 overflow-hidden ${ isRoute && !isScreen ? "" : " closed"}`}             
            //onMouseLeave={onMouseLeave}
            ref={ myRef }
            title={ __( title ) }
        >
            <div className={ `header-menu-element ${ template().header_menu } main-menu-filter-icon ` } onClick={handleLoginOpen}>
                <LayoutIcon
                    src={ icon }
                    className="header-menu-icon"
                    style={{ width: menuHeight - 30 }}
                />
                <span className='header-menu-label px-2 ' title={ __( title ) }>
                    <span className="small">
                        { __( title ) }
                    </span>
                </span>
            </div> 
            <Popover
                className={`indicator-popover ${ isScreen ? "position-relative": "position-absolute top left-important" }`}
                popoverClassName="p-0" 
                position={ isScreen ? Position.BOTTOM_RIGHT : Position.TOP_LEFT }
                isOpen={isOpen}
                modifiers={{
                    arrow: { enabled: false },
                    flip: { enabled: true },
                    preventOverflow: { enabled: false },
                }}
                content={(
                    <div className='overflow-y-auto' style={{maxHeight: `calc(100vh - ${ isScreen ? 150 : 200 }px)`}}>
                        <div className="d-flex flex-column">
                            <Button 
                                className={ `p-0 btn-stretch  ${ landFilter.id === "all" ? " " : "text-force-contrast" }` } 
                                intent={ landFilter.id === "all" ? Intent.DANGER : Intent.NONE } 
                                onClick={() => setFilter("all") }
                            >
                                <div className='d-flex w-100'>
                                    <span className='flex-grow-100 p-3 small '>
                                        { __( "all Lands" ) }
                                    </span> 
                                </div>
                            </Button>
                        {
                            lands.map((land:ILand) =>
                                {
                                    return <Button 
                                        className={ `p-0 btn-stretch ${ landFilter.id === land.id ? " " : " text-force-contrast" }` } 
                                        key={ land.id } 
                                        intent={ landFilter.id === land.id ? Intent.DANGER : Intent.NONE }
                                        onClick={ () => setFilter(land.id) }
                                    >
                                        <div className='d-flex w-100'>
                                            <span className='flex-grow-100 p-3 small '>
                                                { land.name }
                                            </span> 
                                        </div>
                                    </Button>
                                    
                                })
                        }                                    
                        </div>
                    </div>
                )}
            >
                <div style={{ marginTop: 0 }} />
            </Popover>
        </div> 
    </> 
} 

export default LandFilterWidget



 